module.exports = __webpack_public_path__ + "img/PROGRAM_PENDING.619604b4.svg";